module.exports = __webpack_public_path__ + "static/media/hotWaterWrong.40cc1145.png";